/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Scenario_AInputs */

const en_pol_scenario_a = /** @type {(inputs: Pol_Scenario_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On your computer`)
};

const id_pol_scenario_a = /** @type {(inputs: Pol_Scenario_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di komputer kamu`)
};

/**
* | output |
* | --- |
* | "On your computer" |
*
* @param {Pol_Scenario_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_scenario_a = /** @type {((inputs?: Pol_Scenario_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Scenario_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_scenario_a(inputs)
	return en_pol_scenario_a(inputs)
});